import { createReducer, on } from '@ngrx/store';
import { CoreStore } from '../models/core.models';
import { CoreActions } from '../actions/core.actions';

const initialState: CoreStore = {
    
}

export const coreReducer = createReducer(
    initialState,
    on(CoreActions.setRedirectURL, (_state, { redirectUrl } ) => ({ redirectUrl })),
    on(CoreActions.resetRedirectURL, _state => ({
        ..._state,
        redirectUrl: undefined
    }))
)